module.exports = __webpack_public_path__ + "static/media/armani_begin.92d6546f.jpg";